import { createSelector } from 'reselect'
import getLoyaltyLoungePassItems from '../items/getLoyaltyLoungePassItems'
import { nonNullable } from 'lib/array/arrayUtils'
import { getExperienceTimesKey } from 'lib/experiences/experienceUtils'

const getLoyaltyLoungePassItemViews = createSelector(
  (state: App.State) => getLoyaltyLoungePassItems(state),
  (state: App.State) => state.experience.experiences,
  (state: App.State) => state.experience.experienceTimes,
  (state: App.State) => state.geo.currentCurrency,
  (state: App.State) => state.experience.experienceItemsValidation,
  (items, experiences, experienceTimeslots, currencyCode, itemsValidation): App.WithDataStatus<Array<App.Checkout.LoyaltyLoungePassItemView>> => {
    const views = nonNullable(items.map((item): App.Checkout.LoyaltyLoungePassItemView | undefined => {
      const experience = experiences[item.experienceId]
      if (!experience) {
        return
      }

      const key = getExperienceTimesKey(item.experienceId, item.isBookLater ? undefined : item.date, {
        currency: currencyCode,
        redemptionLocationId: experience.redemptionLocations[0].id,
        isBuyNowBookLater: item.isBookLater,
      })
      const timeslots = experienceTimeslots[item.experienceId]?.[key]?.slots

      if (!timeslots) {
        return
      }

      const ticket = timeslots.find(slot => slot.time === item.time)?.tickets.find(ticket => ticket.id === item.ticketId)

      if (!ticket) {
        return
      }

      const itemValidation = itemsValidation[item.itemId]
      const isItemValid = !itemValidation || itemValidation.fetching || itemValidation.isValid

      return {
        title: ticket.name,
        item,
        ticket,
        experience,
        loyalty: {
          productType: 'experience',
        },
        totals: {
          price: item.isFree ? 0 : ticket.price,
          extraGuestSurcharge: 0,
          memberPrice: item.isFree ? 0 : ticket.price,
          memberValue: experience.pricing.value,
          surcharge: 0,
          taxesAndFees: 0,
          value: experience.pricing.value,
        },
        isValid: !!isItemValid,
      }
    }))

    return {
      data: views,
      // views are only populated once we have all the data
      hasRequiredData: views.length === items.length,
    }
  },
)

export default getLoyaltyLoungePassItemViews
